export default "__VITE_ASSET__tTaQ1txi__"